import React from "react";

import printerImg from "../image/thermalprinter.png";
import displayImg from "../image/display.png";
import inverterImg from "../image/batterinv.png";
import stirrerImg from "../image/Ultrasonic-Milk-Stirrer.png";

const accessories = [
  {
    name: "Thermal Printer",
    description: "Print milk data instantly at collection centers.",
    image: printerImg,
  },
  {
    name: "Remote Display",
    description:
      "Visible display for farmers and customers during milk analysis.",
    image: displayImg,
  },
  {
    name: "Battery Inverter",
    description: "Ensure uninterrupted operation during power cuts.",
    image: inverterImg,
  },
  {
    name: "Milk Stirrer",
    description: "Used to stir milk before testing for consistent results.",
    image: stirrerImg,
  },
];

export default function Accessories() {
  return (
    <div className="text-center mb-12">
      <h3 className="text-3xl font-bold text-gray-900 mb-8">Accessories</h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
        {accessories.map((item, idx) => (
          <div
            key={idx}
            className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-2xl shadow hover:shadow-lg transition-shadow"
          >
            <div className="h-40 w-full mb-4 rounded-lg overflow-hidden">
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <h4 className="text-xl font-semibold text-gray-800 mb-2">
              {item.name}
            </h4>
            <p className="text-gray-600 text-sm">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
